import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import { FEEDBACK_SUBMIT_REQUEST, FEEDBACK_SUBMIT_SUCCESS, FEEDBACK_SUBMIT_FAILURE } from '../types';

function postFeedback(data) {
  return api.post('user/feedback.php', { ...data }, {
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  });
}

function* handleSubmitFeedback(action) {
  try {
    const response = yield call(postFeedback, action.payload);
    yield put({ type: FEEDBACK_SUBMIT_SUCCESS, payload: response.data });
  } catch (error) {
    const serverMsg = typeof error?.response?.data === 'string' ? error.response.data : error?.response?.data?.message;
    const message = serverMsg || 'Failed to submit. Please try again.';
    yield put({ type: FEEDBACK_SUBMIT_FAILURE, error: message });
  }
}

export default function* feedbackSaga() {
  yield takeLatest(FEEDBACK_SUBMIT_REQUEST, handleSubmitFeedback);
}
